module.exports = __webpack_public_path__ + "img/16581313_S.7d5ddcd0.png";